import { render, staticRenderFns } from "./region_distribution_analysis.vue?vue&type=template&id=69175c0b&scoped=true"
import script from "./region_distribution_analysis.vue?vue&type=script&lang=js"
export * from "./region_distribution_analysis.vue?vue&type=script&lang=js"
import style0 from "./region_distribution_analysis.vue?vue&type=style&index=0&id=69175c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69175c0b",
  null
  
)

export default component.exports